module.exports = __webpack_public_path__ + "fonts/fa-brands-400.ee26f57.woff";